"use client";

import PillButton from "@/app/shared/PillButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";

const COLOR = 'grey.300';

export default function SellPackagesCTA() {
  return (
    <Box
      sx={{
        textAlign: "center",
        padding: 8,
        color: COLOR,
        background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%)',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        Regularly selling several horses?
      </Typography>
      <Typography>
        Contact us about discounts, plans and business promotion.
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "center",
          marginTop: 2,
        }}
      >
        <a href="tel:+61400105555">
          <PillButton
            startIcon={<CallIcon />}
            sx={{
              "&&&": {
                borderColor: COLOR,
                "&, .MuiSvgIcon-root": {
                  color: COLOR,
                },
                fontWeight: "bold",
                background: "transparent",
              },
            }}
          >
            Call
          </PillButton>
        </a>
        <a href="mailto:support@horsezone.com.au">
          <PillButton
            startIcon={<EmailIcon />}
            sx={{
              "&&&": {
                borderColor: COLOR,
                "&, .MuiSvgIcon-root": {
                  color: COLOR,
                },
                fontWeight: "bold",
                background: "transparent",
              },
            }}
          >
            Email
          </PillButton>
        </a>
      </Box>
    </Box>
  );
}
